import React from 'react'
import Tooltip from 'components/Tooltip'
import { NavigationItemWrapper } from './HeaderNavigation.styles'

interface NavigationItemProps {
  to: string
  collapse?: boolean
}

const NavigationItem: React.FC<NavigationItemProps> = ({
  to,
  collapse,
  children,
}) => {
  return (
    <NavigationItemWrapper to={to} exact>
      {!collapse ? (
        children
      ) : (
        <Tooltip content={children} placement="bottom">
          &hellip;
        </Tooltip>
      )}
    </NavigationItemWrapper>
  )
}

export default NavigationItem
